import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import Form from "../../components/form";
import ActionTable from "../../components/table/ActionTable";
import AppContext from "../../container/context";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function Fretes({ history, location }) {
  const [filtro, setFiltro] = useState(mergeParams({ escolaId: 0 }, location));
  const { notification } = useContext(AppContext);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [comboServicos, setComboServicos] = useState([]);
  const [escola, setEscola] = useState({});
  const [escolas, setEscolas] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [servicoSelecionado, setServicoSelecionado] = useState(false);

  useEffect(() => {
    if (filtro.escolaId > 0) {
      carregar();
    }

    carregarComboEscolas();
    carregarComboServicos();
  }, []);

  const carregarComboEscolas = () => {
    api.get("escolas/listar", { ativas: true }).then((escolas) => {
      setComboEscolas(escolas);
    });
  };

  const carregarComboServicos = () => {
    api
      .get("transportadoras/listarServicosFrete", {
        exibirTransportadorasInativas: true,
      })
      .then((comboServicos) => {
        comboServicos.forEach(
          (servico) =>
            (servico.descricao = `${servico.transportadoraNome} - ${servico.descricao}`)
        );
        setComboServicos(comboServicos);
      })
      .catch((err) => {
        notification(
          "error",
          "Erro ao listar os serviços de frete disponíveis."
        );
      });
  };

  const carregar = (filtroEnviar = filtro) => {
    setFiltro(filtroEnviar);
    setCarregando(true);
    api.get("escolas/servicosFrete", filtroEnviar).then((escola) => {
      setEscola(escola);
      setEscolas(escola.servicos);
      setCarregando(false);
    });
  };

  const fEscolas = {
    title: "Filtros",
    form: {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: filtro.escolaId,
      },
    },

    submit: {
      label: "Carregar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const fDados = {
    title: "Dados Da Escola",
    form: {
      cep: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>CEP</h4>
            <p>{escola.escolaCEP}</p>
          </div>
        ),
      },
      endereco: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Endereço</h4>
            <p>{escola.escolaEndereco}</p>
          </div>
        ),
      },
      municipio: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Município</h4>
            <p>
              {escola.escolaMunicipio} - {escola.escolaUF}
            </p>
          </div>
        ),
      },
    },
  };

  const inserirServico = (params) => {
    api
      .post("escolas/inserirServicoFrete", {
        escolaId: filtro.escolaId,
        servicoFreteId: params.id,
      })
      .then((res) => {
        notification("success", "Serviço inserido!");
        carregar();
        setServicoSelecionado(false);
      })
      .catch((err) =>
        notification("error", "Erro ao inserir serviço de frete")
      );
  };

  const removerServico = (params) => {
    api
      .post("escolas/removerServicoFrete", {
        escolaId: filtro.escolaId,
        servicoFreteId: params.servicoFreteId,
      })
      .then((res) => {
        notification("success", "Serviço removido!");
        carregar();
      })
      .catch((err) =>
        notification("error", "Erro ao remover serviço de frete")
      );
  };

  const tRegistros = {
    title: "Serviços De Frete Para A Escola",
    newItemAction: () => setServicoSelecionado(true),
    columns: [
      {
        name: "transportadoraNome",
        label: "Transportadora",
      },
      {
        name: "servicoFreteDescricao",
        label: "Serviço",
      },
    ],
    actions: [
      {
        name: "remover",
        icon: "zmdi zmdi-delete",
        tooltip: "Remover",
        title: "Remover serviço",
        action: removerServico,
      },
    ],
    array: escolas,
  };

  const fServicos = {
    title: "Incluir serviço",
    form: {
      id: {
        label: "Serviço",
        type: "select",
        emptyItem: true,
        array: {
          data: comboServicos,
          value: "id",
          desc: "descricao",
        },
      },
    },

    submit: {
      label: "incluir",
      action: inserirServico,
    },

    close: {
      label: "Fechar",
      action: () => {
        setServicoSelecionado(false);
      },
    },
  };

  return (
    <div>
      <Form formData={fEscolas} />
      {filtro.escolaId > 0 && (
        <>
          <Form formData={fDados} />
          {servicoSelecionado ? (
            <Form formData={fServicos} />
          ) : (
            <>
              {carregando ? (
                <CircularProgress />
              ) : (
                <ActionTable structure={tRegistros} />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
